export enum EMDTicketDetailError {
  NOT_FOUND,
  TIMEOUT,
  UNHANDLED,
}
